module.exports = __webpack_public_path__ + "media/newstyle/images/100-mil-book-es-4cff73cd7efc3505ec31eb00a8b5feee.svg";